/**
 * Indonesian locale — DEFAULT.
 */
const id = {
  brand: "Azuris Gemological Research",
  tagline: "Sertifikasi, dokumentasi identitas, dan verifikasi batu mulia.",
  comingSoon: "Halaman ini akan diimplementasikan pada tahap berikutnya.",
  sprintNotice: "Institusi Gemologi Tepercaya",
  breadcrumbHome: "Beranda",
  nav: {
    home: "Beranda",
    verification: "Verifikasi Sertifikat",
    process: "Proses Sertifikasi",
    legality: "Legalitas",
    about: "Tentang Azuris",
    contact: "Hubungi Kami",
    login: "Masuk",
    // legacy (tidak ditampilkan publik)
    catalog: "Katalog",
    gemstones: "Batu Mulia",
    jewelry: "Perhiasan",
  },
  footer: {
    rights: "Seluruh hak cipta dilindungi.",
    established: "Institusi Gemologi Tepercaya",
    tagline2: "Sertifikasi · Dokumentasi · Verifikasi",
    adminSignIn: "Masuk Admin",
  },
  home: {
    established: "Institusi Gemologi Tepercaya",
    slides: {
      pillars: {
        eyebrow: "Empat Pilar",
        title: "Empat Pilar Batu Mulia",
        subtitle:
          "Mengenal karakter utama batu mulia yang menjadi bagian penting dalam dunia gemologi.",
        ctaPrimary: "Verifikasi Sertifikat",
        ctaSecondary: "Pelajari Proses Sertifikasi",
        items: {
          diamond: "Berlian",
          ruby: "Rubi",
          sapphire: "Safir",
          emerald: "Zamrud",
        },
      },
      diamondRuby: {
        eyebrow: "Identitas Batu",
        title: "Berlian & Rubi",
        diamond: {
          name: "Berlian",
          desc: "Batu paling keras di bumi yang terkenal karena kilau dan kejernihannya.",
        },
        ruby: {
          name: "Rubi",
          desc: "Batu mulia berwarna merah menyala yang melambangkan kekuatan dan gairah.",
        },
      },
      sapphireEmerald: {
        eyebrow: "Identitas Batu",
        title: "Safir & Zamrud",
        sapphire: {
          name: "Safir",
          desc: "Batu berharga yang umumnya dikenal memiliki warna biru tua yang elegan.",
        },
        emerald: {
          name: "Zamrud",
          desc: "Batu mulia dengan warna hijau khas yang sangat ikonik.",
        },
      },
    },
    promo: {
      eyebrow: "INFORMASI KHUSUS",
      heading: "Sertifikasi Batu Mulia Profesional",
      desc: "Hubungi Azuris Gemological Research untuk jadwal pemeriksaan dan informasi lebih lanjut.",
      cta: "INFORMASI LEBIH LANJUT",
    },
  },
  verify: {
    eyebrow: "Verifikasi Keaslian",
    title: "Verifikasi Sertifikat",
    description:
      "Masukkan nomor sertifikat yang tertera pada dokumen Azuris untuk memeriksa keasliannya.",
    certLabel: "Nomor Sertifikat",
    certPlaceholder: "AGR-ZMD-000015-26",
    codeLabel: "Kode Keamanan",
    codePlaceholder: "Kode pada sertifikat",
    submit: "Verifikasi",
    submitting: "Memeriksa…",
    formatError: "Sertifikat tidak ditemukan.",
    codeRequired: "Kode keamanan wajib diisi.",
    notFound: "Sertifikat tidak ditemukan.",
    authentic: "Sertifikat ini asli dan diterbitkan oleh Azuris Gemological Research (AGR).",
    coverHeading: "Sampul Sertifikat",
    viewDetails: "Lihat Detail Sertifikat",
    pdfTitle: "Sertifikat (4 Halaman)",
    close: "Tutup",
    unavailableTitle: "Layanan Verifikasi Sedang Dipersiapkan",
    unavailable:
      "Layanan verifikasi sedang dipersiapkan. Tidak ada data sertifikat yang ditampilkan sebelum sistem verifikasi aktif.",
    emptyHint:
      "Setiap sertifikat Azuris memiliki nomor unik dan dapat diverifikasi secara digital.",
  },
  process: {
    eyebrow: "Alur Kerja",
    title: "Proses Sertifikasi",
    subtitle:
      "Setiap batu melewati alur pemeriksaan yang terdokumentasi dan dapat diverifikasi.",
    steps: {
      register: {
        title: "Pendaftaran Batu",
        desc: "Pencatatan data awal dan penerimaan batu untuk diperiksa.",
      },
      examine: {
        title: "Pemeriksaan Fisik & Gemologi",
        desc: "Analisis fisik dan gemologi untuk mengidentifikasi karakteristik batu.",
      },
      document: {
        title: "Dokumentasi Hasil",
        desc: "Pencatatan hasil pemeriksaan secara rinci dan terstruktur.",
      },
      issue: {
        title: "Penerbitan Sertifikat",
        desc: "Penerbitan sertifikat dengan nomor unik yang dapat diverifikasi.",
      },
      verify: {
        title: "Verifikasi Digital",
        desc: "Pemeriksaan keaslian sertifikat melalui sistem verifikasi digital.",
      },
    },
  },
  why: {
    eyebrow: "Keunggulan",
    title: "Mengapa Memilih Azuris",
    subtitle:
      "Fokus kami adalah pemeriksaan, dokumentasi, dan verifikasi batu mulia yang profesional.",
    items: {
      examination: {
        title: "Pemeriksaan Gemologi",
        desc: "Pemeriksaan gemologi yang teliti dan objektif.",
      },
      documentation: {
        title: "Dokumentasi Identitas",
        desc: "Dokumentasi identitas batu yang lengkap dan konsisten.",
      },
      verification: {
        title: "Verifikasi Keaslian",
        desc: "Verifikasi keaslian sertifikat kapan saja secara digital.",
      },
      integrity: {
        title: "Integritas Dokumen",
        desc: "Perlindungan integritas dokumen dan transparansi data.",
      },
    },
  },
  standards: {
    eyebrow: "Standar",
    title: "Standar Pemeriksaan",
    subtitle: "Setiap batu diperiksa berdasarkan aspek gemologi utama.",
    items: {
      species: {
        title: "Identifikasi Spesies & Varietas",
        desc: "Penentuan jenis dan varietas batu berdasarkan analisis gemologi.",
      },
      color: {
        title: "Karakteristik Warna & Kejernihan",
        desc: "Penilaian warna, transparansi, dan karakteristik kejernihan.",
      },
      treatment: {
        title: "Indikasi Perlakuan",
        desc: "Identifikasi indikasi perlakuan pada batu bila ada.",
      },
      photo: {
        title: "Dokumentasi Foto",
        desc: "Dokumentasi visual sebagai bagian dari laporan pemeriksaan.",
      },
    },
  },
  legalityTeaser: {
    eyebrow: "Kredibilitas",
    title: "Legalitas dan Kredibilitas",
    body: "Azuris Gemological berkomitmen pada layanan pemeriksaan, identifikasi, dokumentasi, dan sertifikasi batu mulia yang profesional dan dapat diverifikasi.",
    cta: "Lihat Legalitas",
  },
  contact: {
    eyebrow: "Hubungi Kami",
    title: "Hubungi Azuris",
    subtitle:
      "Hubungi tim Azuris untuk pertanyaan seputar pemeriksaan, sertifikasi, dan verifikasi batu mulia.",
    whatsapp: "Hubungi via WhatsApp",
    moreInfo: "INFORMASI LEBIH LANJUT",
  },
  homeMembership: {
    eyebrow: "Keanggotaan",
    title: "Keanggotaan Azuris",
    desc: "Identitas keanggotaan digital yang terhubung dengan data pemilik dan dapat diverifikasi melalui sistem Azuris.",
    cta: "Verifikasi Keanggotaan",
  },
  legality: {
    title: "Legalitas Azuris Gemological",
    subtitle:
      "Komitmen terhadap pemeriksaan, identifikasi, dan penerbitan sertifikat batu mulia yang profesional dan dapat diverifikasi.",
    ctaVerify: "Verifikasi Sertifikat Batu",
    viewerTitle: "Dokumen Legalitas",
    emptyTitle: "Dokumen Belum Dipublikasikan",
    empty:
      "Dokumen legalitas resmi belum dipublikasikan. Informasi akan ditampilkan di sini setelah tersedia dan disahkan oleh Azuris Gemological.",
    copyTitle: "Komitmen Kami",
    copy: "Sertifikat ini menjadi bagian dari komitmen Azuris Gemological dalam menjalankan layanan pemeriksaan, identifikasi, dokumentasi, dan sertifikasi batu mulia secara profesional. Setiap sertifikat batu yang diterbitkan Azuris memiliki nomor unik dan dapat diverifikasi melalui sistem verifikasi digital.",
    disclaimerTitle: "Disclaimer",
    disclaimer:
      "Sertifikat gemologi merupakan laporan hasil pemeriksaan dan identifikasi batu mulia. Sertifikat tidak secara otomatis menjadi jaminan harga, nilai investasi, kepemilikan, atau asal-usul hukum suatu batu.",
  },
  verifyResult: {
    validTitle: "Sertifikat Terverifikasi",
    valid: "Sertifikat ini asli dan aktif.",
    archivedTitle: "Sertifikat Diarsipkan",
    archived: "Versi sertifikat ini telah diarsipkan.",
    revokedTitle: "Sertifikat Dicabut",
    revoked: "Sertifikat ini telah dicabut dan tidak berlaku.",
    expiredTitle: "Sertifikat Kedaluwarsa",
    expired: "Sertifikat ini telah kedaluwarsa.",
    notFoundTitle: "Tidak Dapat Diverifikasi",
    notFound: "Kombinasi nomor sertifikat dan kode keamanan tidak dapat diverifikasi.",
    errorTitle: "Terjadi Kesalahan",
    error: "Tidak dapat memproses verifikasi saat ini. Silakan coba lagi.",
    showDetails: "Tampilkan Detail",
    qrDetected: "Kode QR terdeteksi. Tekan Tampilkan Detail untuk memverifikasi.",
    certificatePreview: "Pratinjau Sertifikat",
    verifiedCertificate: "Sertifikat Terverifikasi",
    viewDigitalCertificate: "Lihat Sertifikat Digital",
    previewUnavailable: "Pratinjau sertifikat tidak tersedia",
    sectionBasic: "Informasi Sertifikat",
    sectionGemstone: "Identitas Batu",
    sectionResult: "Hasil Pemeriksaan",
    sectionOwner: "Pemilik",
    fields: {
      number: "Nomor Sertifikat", version: "Versi", issue: "Tanggal Terbit",
      owner: "Pemilik", species: "Spesies", carat: "Berat", color: "Warna",
      clarity: "Kejernihan", cut: "Potongan", shape: "Bentuk", origin: "Asal",
      treatment: "Perlakuan", conclusion: "Kesimpulan",
    },
  },
  auth: {
    subtitle: "Masuk ke panel admin Azuris.",
    email: "Email", password: "Kata Sandi",
    signIn: "Masuk", signingIn: "Memproses…",
    error: "Email atau kata sandi salah.", logout: "Keluar",
  },
  adminNav: { legality: "Legalitas", settings: "Pengaturan", customers: "Pelanggan", gemstones: "Batu Mulia", jewelry: "Perhiasan", warranties: "Garansi", ownership: "Kepemilikan", membership: "Kartu Anggota" },
  adminLegality: {
    title: "Kelola Legalitas",
    subtitle: "Kelola dokumen legalitas resmi Azuris yang ditampilkan publik.",
    create: "Tambah Kredensial", name: "Nama Sertifikat", holder: "Pemegang / Institusi",
    number: "Nomor Sertifikat", issuer: "Penerbit", issueDate: "Tanggal Terbit",
    expiry: "Tanggal Kedaluwarsa", status: "Status", description: "Deskripsi Singkat",
    download: "Izinkan unduh publik", document: "Dokumen Sertifikat", upload: "Unggah Dokumen",
    save: "Simpan", publish: "Publikasikan", unpublish: "Batalkan Publikasi", delete: "Hapus",
    published: "Dipublikasikan", draft: "Draf", empty: "Belum ada kredensial legalitas.",
    saved: "Tersimpan.", uploaded: "Dokumen terunggah.",
    signatoryName: "Nama Penanda Tangan Berwenang", signatoryPosition: "Jabatan",
    activeForCerts: "Aktif untuk Sertifikat Baru", activeBadge: "Aktif untuk Sertifikat",
    signature: "Gambar Tanda Tangan", uploadSignature: "Unggah Tanda Tangan", replaceSignature: "Ganti Tanda Tangan",
    removeSignature: "Hapus Tanda Tangan", signaturePreview: "Pratinjau Tanda Tangan",
    signatureHint: "PNG dengan latar transparan lebih disarankan (JPG/WebP juga didukung, maks 5MB).",
    signatureUploaded: "Tanda tangan terunggah.", signatureRemoved: "Tanda tangan dihapus.",
    saveFirst: "Simpan kredensial terlebih dahulu, lalu unggah tanda tangan.",
  },
  adminSettings: {
    title: "Pengaturan Kontak",
    subtitle: "Nomor WhatsApp bisnis yang digunakan seluruh tombol kontak publik.",
    whatsapp: "Nomor WhatsApp Bisnis", label: "Label (opsional)", enabled: "Aktifkan WhatsApp",
    save: "Simpan Perubahan", saved: "Perubahan tersimpan.",
    hint: "Contoh: 087812128884 atau +62 878-1212-8884",
    invalid: "Nomor WhatsApp tidak valid.",
  },
  adminVisuals: {
    navTitle: "Visual & Konten",
    title: "Kontrol Visual CMS",
    subtitle: "Kelola visual publik: gambar login admin, gambar proses sertifikasi, dan bagian keanggotaan pada beranda.",
    loginSection: "Gambar Login Admin",
    processSection: "Gambar Proses Sertifikasi",
    membershipSection: "Keanggotaan Beranda",
    imageUrl: "URL Gambar (Media Library / aset)",
    altId: "Teks Alt (ID)", altEn: "Teks Alt (EN)",
    show: "Tampilkan bagian", preview: "Pratinjau",
    titleId: "Judul (ID)", titleEn: "Judul (EN)",
    descId: "Deskripsi (ID)", descEn: "Deskripsi (EN)",
    ctaId: "Teks CTA (ID)", ctaEn: "Teks CTA (EN)", link: "Tautan Tujuan",
    save: "Simpan Visual", saved: "Visual tersimpan.",
    readOnly: "Anda hanya memiliki akses baca untuk kontrol ini.",
    uploadBtn: "Upload Gambar",
    pickBtn: "Pilih dari Media",
    change: "Ganti",
    reset: "Reset Default",
    advancedUrl: "URL / Aset (lanjutan)",
    uploading: "Mengunggah…",
    pickerTitle: "Pilih Gambar dari Media",
    pickerEmpty: "Belum ada gambar. Upload gambar terlebih dahulu.",
    invalidType: "Format tidak didukung. Gunakan JPG, PNG, atau WebP.",
    uploadFailed: "Upload gagal. Coba lagi.",
    close: "Tutup",
    dashboardSection: "Background Dashboard",
    dashboardHint: "Atur latar belakang panel admin. Nonaktif = memakai marble default Azuris.",
    bgEnabled: "Aktifkan background kustom",
    bgOpacity: "Intensitas / Opasitas",
    bgFit: "Perataan Gambar",
    fitCover: "Penuh (Cover)",
    fitCenter: "Tengah (Center)",
    bgBlur: "Blur",
    resetMarble: "Reset ke Background Marble Default",
    loginSectionBg: "Background Halaman Login",
    loginBgHint: "Atur latar belakang halaman login admin agar konsisten dengan dashboard.",
    resetLoginBg: "Reset Background Login",
    homeBgSection: "Background Beranda",
    homeBgHint: "Atur gambar latar hero halaman Beranda. Nonaktif = memakai marble default Azuris.",
    resetHomeBg: "Reset ke Background Default",
    homeGemsSection: "Foto Batu Beranda",
    homeGemsHint: "Ganti foto batu mulia yang tampil di hero Beranda (Berlian, Rubi, Safir, Zamrud).",
    gemDiamond: "Berlian",
    gemRuby: "Rubi",
    gemSapphire: "Safir",
    gemEmerald: "Zamrud",
    promoSection: "Slide Promosi Beranda",
    promoHint: "Slide promosi tampil pertama di hero Beranda. Kosongkan teks untuk memakai pesan default.",
    promoImage: "Gambar Promosi (opsional)",
    promoEyebrowId: "Eyebrow (ID)", promoEyebrowEn: "Eyebrow (EN)",
    promoHeadingId: "Judul (ID)", promoHeadingEn: "Judul (EN)",
    promoDescId: "Deskripsi (ID)", promoDescEn: "Deskripsi (EN)",
    promoCtaId: "Teks CTA (ID)", promoCtaEn: "Teks CTA (EN)",
  },
  adminCert: {
    navTitle: "Sertifikat",
    title: "Penerbitan Sertifikat",
    subtitle: "Buat data batu, terbitkan sertifikat, lalu hasilkan QR dan PDF A6.",
    newGem: "Data Batu Baru",
    gemNameId: "Nama Batu (ID)", gemName: "Nama Batu (EN)", category: "Kategori",
    type: "Spesies / Jenis", carat: "Berat (ct)", color: "Warna", clarity: "Kejernihan",
    cut: "Potongan", shape: "Bentuk", dimensions: "Dimensi (mm)", origin: "Asal", treatment: "Perlakuan",
    kodeBatu: "Kode Batu",
    kodeBatuHelper: "Masukkan tepat 3 huruf. Contoh: Zamrud = ZMD.",
    kodeBatuError: "Kode batu wajib terdiri dari tepat 3 huruf.",
    kodeBatuRequired: "Kode Batu diperlukan",
    sampleCard: "Contoh Kartu",
    createGem: "Simpan Batu", uploadPhoto: "Unggah Foto", issue: "Terbitkan Sertifikat",
    examiner: "Pemeriksa", conclusion: "Kesimpulan Identifikasi",
    issued: "Sertifikat diterbitkan.",
    securityCodeNote: "Simpan kode keamanan ini — hanya ditampilkan sekali:",
    qrNote: "URL QR:", gemstones: "Batu Terdaftar", certificates: "Sertifikat",
    pdf: "Unduh PDF", card: "Kartu", revoke: "Cabut", revoked: "Dicabut.",
    noGem: "Belum ada batu.", issuedBadge: "Bersertifikat",
    demoPreview: "Lihat Contoh Sertifikat",
    demoTitle: "Contoh Sertifikat (Pratinjau Demo)",
    demoNote: "Pratinjau desain saja. Bukan sertifikat asli — tidak tersimpan, tidak diverifikasi, dan tidak memengaruhi penomoran.",
    demoOpenPdf: "Buka PDF",
    demoClose: "Tutup",
  },
  adminCustomers: {
    title: "Pelanggan", subtitle: "Kelola data pemilik batu mulia. Data kontak tidak pernah ditampilkan publik.",
    search: "Cari nama, email, telepon…", add: "Tambah Pelanggan", edit: "Ubah", save: "Simpan", cancel: "Batal", delete: "Hapus",
    fullName: "Nama Lengkap", email: "Email", phone: "Telepon", address: "Alamat", notes: "Catatan",
    consent: "Persetujuan privasi tercatat", consentAt: "Persetujuan pada", empty: "Belum ada pelanggan.",
    confirmDelete: "Hapus pelanggan ini?",
  },
  adminGemstones: {
    title: "Batu Mulia", subtitle: "Kelola katalog batu mulia — status, media, dan pencarian.",
    search: "Cari nama, jenis, asal…", add: "Tambah Batu", edit: "Ubah", save: "Simpan", cancel: "Batal", delete: "Hapus",
    nameId: "Nama (ID)", nameEn: "Nama (EN)", category: "Kategori", type: "Spesies / Jenis", carat: "Berat (ct)",
    color: "Warna", clarity: "Kejernihan", cut: "Potongan", shape: "Bentuk", dimensions: "Dimensi (mm)", origin: "Asal", treatment: "Perlakuan",
    status: "Status", allStatus: "Semua status", media: "Media", uploadMedia: "Unggah Media", setMain: "Jadikan Utama",
    empty: "Belum ada batu.", confirmDelete: "Hapus batu ini?", hasCert: "Bersertifikat — tidak dapat dihapus", updateStatus: "Ubah Status",
  },
  adminJewelry: {
    title: "Perhiasan", subtitle: "Kelola perhiasan yang tersusun dari satu atau lebih batu mulia.",
    search: "Cari nama, jenis, bahan…", add: "Tambah Perhiasan", edit: "Ubah", save: "Simpan", cancel: "Batal", delete: "Hapus",
    nameId: "Nama (ID)", nameEn: "Nama (EN)", type: "Jenis Perhiasan", material: "Bahan", weight: "Berat (gram)",
    dimensions: "Dimensi (mm)", gemstones: "Batu Terkait", status: "Status", allStatus: "Semua status",
    empty: "Belum ada perhiasan.", confirmDelete: "Hapus perhiasan ini?", noGems: "Belum ada batu untuk dipilih.", updateStatus: "Ubah Status",
  },
  adminWarranty: {
    title: "Garansi", subtitle: "Kelola garansi per batu mulia — masa berlaku, status, dan versi.",
    add: "Tambah Garansi", reissue: "Terbitkan Ulang", save: "Simpan", cancel: "Batal", delete: "Hapus",
    gemstone: "UUID Batu Mulia", termsId: "Ketentuan (ID)", termsEn: "Ketentuan (EN)",
    period: "Masa (bulan)", startDate: "Tanggal Mulai", endDate: "Tanggal Berakhir",
    number: "Nomor Garansi", status: "Status", version: "Versi", allStatus: "Semua status",
    setVoid: "Batalkan (void)", setExpired: "Tandai Kedaluwarsa", empty: "Belum ada garansi.",
    confirmDelete: "Hapus garansi ini?", filterGem: "Filter UUID batu",
  },
  adminOwnership: {
    title: "Kepemilikan", subtitle: "Kepemilikan resmi antara pelanggan dan batu mulia. Kepemilikan hanya berubah melalui alur transfer.",
    gemLabel: "UUID Batu Mulia", load: "Muat", currentOwner: "Pemilik Saat Ini", noOwner: "Belum ada pemilik.",
    gemStatus: "Status Batu", assign: "Tetapkan Pemilik Awal", owner: "Pemilik", selectCustomer: "Pilih pelanggan…",
    newTransfer: "Transfer Baru", recipient: "Penerima", create: "Buat Transfer", pending: "Transfer Tertunda",
    complete: "Selesaikan", cancel: "Batalkan", history: "Riwayat Kepemilikan", noHistory: "Belum ada riwayat.",
    codeNote: "Kode keamanan baru (disimpan sekali):", masked: "Nama tersamar", from: "Dari", to: "Ke",
    notFound: "Batu tidak ditemukan.",
  },
  adminMembership: {
    title: "Kartu Anggota", subtitle: "Kartu identitas anggota Azuris premium. Menampilkan identitas tersamar — tanpa data pribadi.",
    add: "Terbitkan Kartu", customer: "Pelanggan", selectCustomer: "Pilih pelanggan (dengan persetujuan)…",
    create: "Terbitkan", cancel: "Batal", memberId: "ID Anggota", memberName: "Nama Anggota", memberSince: "Anggota Sejak",
    status: "Status", version: "Versi", activate: "Aktifkan", deactivate: "Nonaktifkan", reissue: "Terbitkan Ulang",
    delete: "Hapus", viewCard: "Lihat Kartu", empty: "Belum ada kartu anggota.", confirmDelete: "Hapus kartu ini?",
    cardTitle: "KARTU ANGGOTA", statement: "Anggota terverifikasi Azuris Gemological.", scan: "Pindai untuk memverifikasi keanggotaan.",
    close: "Tutup", front: "Depan", back: "Belakang",
  },
  membershipVerify: {
    title: "Verifikasi Keanggotaan", checking: "Memeriksa…",
    valid: "Keanggotaan Azuris Aktif", inactive: "Keanggotaan Tidak Aktif", invalid: "Kartu tidak dapat diverifikasi.",
    memberId: "ID Anggota", memberName: "Nama Anggota", memberSince: "Anggota Sejak", status: "Status",
  },
  admin: {
    title: "Panel Admin",
    dashboard: "Dasbor",
    dash: {
      eyebrow: "Ikhtisar Operasional",
      subtitle: "Ringkasan aktivitas platform yang teragregasi dan aman privasi.",
      refresh: "Muat Ulang",
      loading: "Memuat analitik…",
      error: "Gagal memuat analitik.",
      records: "Total Data",
      certificates: "Sertifikat",
      verifications: "Verifikasi (30 hari)",
      customers: "Pelanggan",
      gemstones: "Batu Mulia",
      jewelry: "Perhiasan",
      warranties: "Garansi",
      transfers: "Transfer Kepemilikan",
      memberships: "Kartu Anggota",
      media: "Media",
      verifyTrend: "Tren Verifikasi (14 hari)",
      verifyTotal: "Total Verifikasi",
      verifySuccess: "Berhasil",
      byStatus: "Rincian per Status",
      gemStatus: "Status Batu Mulia",
      certStatus: "Status Sertifikat",
      warrantyStatus: "Status Garansi",
      transferStatus: "Status Transfer",
      membershipStatus: "Status Kartu Anggota",
      verifyResults: "Hasil Verifikasi (30 hari)",
      adminActivity: "Aktivitas Admin (30 hari)",
      counter: "Penomoran Sertifikat",
      nextCertificate: "Nomor Sertifikat Berikutnya",
      lastNumber: "Nomor Terakhir",
      noData: "Belum ada data.",
      generatedAt: "Diperbarui",
    },
  },
  language: {
    label: "Bahasa",
    id: "Indonesia",
    en: "Inggris",
  },
} as const;

export default id;
